import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import UploadFile from "../../Components/UploadFile";
import { TokenContext } from "../../Components/TokenContext";
import ListIsee from "../../Components/ListIsee";
import ListPaymemtsUsers from "../../Components/listPaymentsUser";
import  ValidISEE  from "../../Components/ValidISEE";
import  ValidUser  from "../../Components/ValidUser";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ViewAnnouncements(props) {
  const apiToken = useContext(TokenContext);
  let query = useQuery();
  const [session, setSession] = useState({});
  const [isOpen, toggleModal] = useState(false);
  const [isOpenResult, toggleModalResult] = useState(false);
  const [isOpenError, toggleModalError] = useState(false);
  const [subscriptionsId] = useState(query.get("id"));
  const [messageError, setMessageError] = useState("");
  const [file, setFile] = useState();
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [paymentsTemp, setPaymentsTemp] = useState();
  const [payments, setPayments] = useState();
  const [countRender, setCountRender] = useState(0);
  const [uploadFile1, setUploadFile1] = useState();
  const [uploadFile2, setUploadFile2] = useState();
  const [uploadFile3, setUploadFile3] = useState();
  const [uploadFile4, setUploadFile4] = useState();
  const [uploadFile5, setUploadFile5] = useState();

  const [count, setCount] = useState(1);

  const addFile = async () => {
    if (count < 5) {
      setCount(count + 1);
    }
  };

  const removeFile = async () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  useEffect(() => {
    if (apiToken) {
      if (query.get("id")) {
        Repo.getSessionByIdUser(apiToken, query.get("id"))
          .then((response) => {
            if (response.status == 200) {
              setSession(response.data);
              setCountRender(1);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
      }
    }
  }, []);

  useEffect(() => {
    if (countRender > 0 && session.subscriptions.length > 0) {
      Repo.getListPaymentUser(apiToken, session.subscriptions[0].id)
        .then((response) => {
          if (response.status == 200) {
            setPaymentsTemp(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [countRender]);

  const sendSubscription = () => {
    var temp = {
      announcementId: subscriptionsId,
      listBase64: [],
    };

    for (let i = 1; i <= count; i++) {
      if (i == 1 && uploadFile1) {
        var splitBase64 = uploadFile1.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 2 && uploadFile2) {
        var splitBase64 = uploadFile2.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 3 && uploadFile3) {
        var splitBase64 = uploadFile3.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 4 && uploadFile4) {
        var splitBase64 = uploadFile4.split(",");
        temp["listBase64"].push(splitBase64[1]);
      } else if (i == 5 && uploadFile5) {
        var splitBase64 = uploadFile5.split(",");
        temp["listBase64"].push(splitBase64[1]);
      }
    }

    Repo.postSubscriptionUser(apiToken, JSON.stringify(temp))
      .then((response) => {
        if (response.status == 200) {
          toggleModalResult(true);
          toggleModal(false);
          setTimeout(function () {
            window.location.reload(1);
          }, 2000);
        }
      })
      .catch((error) => {
        if (error.response.status == 400) {
          toggleModalError(true);
          toggleModal(false);
          console.log(error.response.data);
          setMessageError(error.response.data);
        }
        console.log(error);
      });
  };

  const doPayment = (iuv) => {
    Repo.getPayment(apiToken, iuv)
      .then((response) => {
        if (response.status == 200) {
          window.open(response.data, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const reload = () => {
    window.location.reload(1);
  };

  const returnVarName = (index) => {
    switch (index) {
      case 1:
        return setUploadFile1;
      case 2:
        return setUploadFile2;
      case 3:
        return setUploadFile3;
      case 4:
        return setUploadFile4;
      case 5:
        return setUploadFile5;

      default:
        break;
    }
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const showFile = (id) => {
    Repo.downloadFileUser(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setFile();
          var obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);

          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fileListDownload = () => {
    return (
      <>
        <hr/>
        {session.announcementFiles && session.announcementFiles.length > 0 && (
          <h5 className="mt-4">
            <b>Modulista caricata dal comune</b>
          </h5>
        )}
        <div className="row ">
          {session.announcementFiles &&
            session.announcementFiles.length > 0 &&
            session.announcementFiles.map((x, index) => (
              <React.Fragment key={x.storageFileId}>
                <div className="col-2">
                  <button
                    className="btn btn-primary"
                    onClick={() => showFile(x.storageFileId)}
                  >
                    Modulo {index + 1}
                  </button>
                </div>
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  const fileListDownloadUser = () => {
    return (
      <>
        <h5>
          <b>File caricati </b>
        </h5>
        <div className="row">
          {session.subscriptions[0].subscriptionFiles.map((x, index) => (
            <React.Fragment key={x.storageFileId}>
              <div className="col-3">
                <button
                  className="btn btn-primary"
                  onClick={() => showFile(x.storageFileId)}
                >
                  Visualizza File {index + 1}
                </button>
              </div>
            </React.Fragment>
          ))}
        </div>
      </>
    );
  };

  const fileListUpload = () => {
    return (
      <>
        <div className="row mb-4">
          <div className="col-12 text-right">
            <button className="btn btn-primary" onClick={() => addFile()}>
              <svg className="icon icon-white mr-2">
                <use href={`${iconSprite}#it-plus-circle`}></use>
              </svg>
              Aggiungi file
            </button>
          </div>
        </div>
        <div className="row ">
          {count &&
            [...Array(count)].map((x, index) => (
              <React.Fragment key={index}>
                <div className="col-6 mb-5">
                  <UploadFile
                    setErrorMessage={setErrorMessage}
                    typeFile={[
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ]}
                    testoCaricamento="File caricato correttamente"
                    testoInterno="Carica File"
                    testoTitolo=" "
                    handleFile={returnVarName(index + 1)}
                  ></UploadFile>
                </div>
              </React.Fragment>
            ))}
        </div>
      </>
    );
  };

  return (
    <>
     <ValidISEE />
    <ValidUser />

      <div className="row mb-3">
        <div className="col-lg-9">
          <h1>{session && session.name} </h1>
        </div>
        {session.subscriptions && session.subscriptions.length < 1 ? (
          <div className="col-lg-3">
            <button
              onClick={() => toggleModal(!isOpen)}
              className="btn btn-primary float-right"
            >
              Richiedi Servizio
            </button>
          </div>
        ) : session.subscriptions &&
          session.subscriptions[0].state == "VALIDATED" ? (
          <div className="col-lg-3 text-right">
            <svg className="icon icon-success mr-2">
              <use xlinkHref={`${iconSprite}#it-check-circle`}></use>
            </svg>
            <b className="text-success">
              {"Richiesta approvata".toUpperCase()}
            </b>
          </div>
        ) : session.subscriptions &&
          session.subscriptions[0].state == "SUSPENDED" ? (
          <div className="col-lg-3 text-right">
            <svg className="icon icon-dark mr-2">
              <use xlinkHref={`${iconSprite}#it-ban`}></use>
            </svg>
            <b className="text-dark">{"Iscrizione sospesa".toUpperCase()}</b>
          </div>
        ) : session.subscriptions &&
          session.subscriptions[0].state == "ADDED" ? (
          <div className="col-lg-3 text-right">
            <svg className="icon icon-warning mr-2">
              <use xlinkHref={`${iconSprite}#it-warning-circle`}></use>
            </svg>
            <b className="text-warning">{"Richiesta inviata".toUpperCase()}</b>
          </div>
        ) : (
          session.subscriptions &&
          session.subscriptions[0].state == "REFUSED" && (
            <div className="col-lg-3 text-right">
              <svg className="icon icon-danger mr-2">
                <use xlinkHref={`${iconSprite}#it-close-circle`}></use>
              </svg>
              <b className="text-danger">
                {"Richiesta rifiutata".toUpperCase()}
              </b>
            </div>
          )
        )}
      </div>
      <div className="card-wrapper card-space col-lg-12">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            {session ? (
              <>
                <div className="row">
                  {/* {session.cost && (
                    <div className="col-lg-4">
                      Costo Prestazione:{" "}
                      <span className="text">
                        <b>{session.cost} €</b>
                      </span>
                    </div>
                  )} */}

                  {session.service && (
                    <>
                      <div className="col-lg-4">
                        Servizio:{" "}
                        <span className="text">
                          <b>{session.service.name} </b>
                        </span>
                      </div>
                    </>
                  )}
                </div>
                {session.service && (
                  <div className="row mt-3">
                    <div className="col-lg-12">
                    
                      <span className="text">
                        <p>{session.service.description}</p>
                      </span>
                    </div>
                  </div>
                )}

              
                {session.subscriptions &&
                  session.subscriptions.length > 0 &&
                  session.subscriptions[0].state == "VALIDATED" && (
                    <div className="row">
                      <div className="col-12">
                        <h6>
                          In seguito all'approvazione della tua richiesta:
                        </h6>
                      </div>
                      <div className="col-12 col-lg-6">
                        <p>
                          Costo Mensile:{" "}
                          <strong>
                            {session.subscriptions[0].cost &&
                              parseFloat(
                                session.subscriptions[0].cost
                              ).toLocaleString("it-IT")}
                            {" € "}
                          </strong>
                        </p>
                      </div>
                      <div className="col-12 col-lg-6">
                        <p>
                          Ore Settimanali:{" "}
                          <strong>{session.subscriptions[0].weeklyHour}</strong>
                        </p>
                      </div>
                    </div>
                  )}

                <hr className="pb-4" />

                <ListIsee bands={session.bands}></ListIsee>
              </>
            ) : (
              <>
                <span className="text">
                  Il bando selezionata non è presente.
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      {paymentsTemp && paymentsTemp.length > 0 && (
        <ListPaymemtsUsers
          payments={payments}
          paymentsTemp={paymentsTemp}
          setPayments={setPayments}
        />
      )}

      {session.subscriptions && session.subscriptions.length < 1 ? (
        <div className="card-wrapper card-space col-lg-12">
          <div className="card card-bg card-big roundedCustom no-after">
            <div className="card-body">
              <hr className="pb-4" />
              <h5 className="mt-4">
                <b>Carica Modulistica</b>
              </h5>
              <p>
                Procedi con il caricamento della modulistica aggiuntiva o di
                documenti utili (es: certificato medico, ecc..). <br />
                In seguito clicca su <strong>RICHIEDI SERVIZIO</strong>.
              </p>
              {fileListUpload()}
              {fileListDownload()}
            </div>
          </div>
        </div>
      ) : (
        session.subscriptions &&
        session.subscriptions[0].subscriptionFiles.length > 0 && (
          <div className="card-wrapper card-space col-lg-12">
            <div className="card card-bg card-big roundedCustom no-after">
              <div className="card-body">
                {fileListDownloadUser()} {fileListDownload()}
              </div>
            </div>
          </div>
        )
      )}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Iscrizione servizio"
        body="Confermi di voler iscriverti al servizio scelto"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendSubscription()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModalResult}
        isOpen={isOpenResult}
        header="Richiesta inviata"
        body="La tua richiesta di iscrizione è stata inviata correttamente"
        buttonConfirm="Ricarica"
        function={() => reload()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={toggleModalError}
        isOpen={isOpenError}
        header="RICHIESTA RIFIUTATA"
        body={messageError}
        buttonConfirm="Chiudi"
        function={() => reload()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>
    </>
  );
}

export default ViewAnnouncements;
